import { ThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import React, { useEffect, useState } from 'react'

import Routes from './routes'
import PortalStatusScreen from './components/PortalStatusScreen'
import PublicCallSwitchGuard from './components/PublicCallSwitchGuard'
import { appService } from './services'
import portalConfig from './services/portalConfig'
import { colors } from './utils'
import applyDocumentHead from './utils/documentHead'

const { STATUS } = portalConfig

const App = () => {
  const [status, setStatus] = useState(portalConfig.getStatus())
  const [boot, setBoot] = useState(null)

  useEffect(() => portalConfig.subscribe(setStatus), [])

  useEffect(() => {
    const start = async () => {
      const config = await portalConfig.load()

      if (!config) return

      applyDocumentHead(colors.portalTheme())
      setBoot(await appService.bootstrap())
    }

    start()
  }, [])

  const renderContent = () => {
    if (status !== STATUS.ready) return <PortalStatusScreen status={status} />
    if (!boot) return <PortalStatusScreen status="loading" />

    return (
      <>
        <Routes needsChoice={boot.needsChoice} />
        <PublicCallSwitchGuard />
      </>
    )
  }

  return (
    <ThemeProvider theme={colors.theme}>
      <CssBaseline />
      {renderContent()}
    </ThemeProvider>
  )
}

export default App
